import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamsEmptyState = style([
  {
    padding: `${space.s28}px 0`,
  },
]);
